import {
  Box,
  TextField,
  Button,
  Grid,
  Avatar,
  Typography,
} from "@mui/material";
import PageTitle from "../../components/Layout/PageTitle";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import APIAxios from "../../Api/APIAxios";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { GetAPI } from "../../Components/Backend/GetAPI";
import { PutAPI } from "../../Components/Backend/PutAPI";
import InputAdornment from "@mui/material/InputAdornment";
import PersonIcon from "@mui/icons-material/Person";
import EmailIcon from "@mui/icons-material/Email";
import LockIcon from "@mui/icons-material/Lock";
import { validarEmail } from "../../Components/Funcionais/Utils";
import { validarSenha } from "../../Components/Funcionais/Utils";
import IconButton from "@mui/material/IconButton";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import SessaoAuth from "../../Hooks/SessaoAuth";
import BadgeIcon from "@mui/icons-material/Badge";

const MinhaContaAlterar = () => {
  const { sessao } = SessaoAuth();

  //***************************************   AVISOS E LOADING ************************************************* */
  // CONTROLE DE AVISOS E ALERTAS
  //Funcão para fechar avisos e alertas
  const [avisoErro, setAvisoErro] = useState("");
  const [avisoSucesso, setAvisoSucesso] = useState("");
  const [loading, setLoading] = useState(false);
  //************************************************************************************************** */

  const apiAxios = APIAxios();
  const navigate = useNavigate();
  const [confSenha, setConfSenha] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [senhaValida, setSenhaValida] = useState(false);
  const [emailError, setEmailError] = useState(false);
  const MAX_SIZE = 2 * 1024 * 1024; // 2MB

  const [formData, setFormData] = useState({
    cargo: "",
    email: "",
    id: 0,
    idEmpresa: 0,
    idPerfil: 0,
    nome: "",
    status: "A",
    tipo: "A",
    nomPerfil: "",
    senha: "",
    datAceite: "",
  });

  // Este estado guarda a URL temporária para exibir a imagem na tela
  const [previewUrl, setPreviewUrl] = useState(null);

  const buscarUsuario = async () => {
    setLoading(true);

    if (!sessao?.authToken?.idUsuario) {
      setAvisoErro("Usuário não identificado.");
      setLoading(false);
      return;
    }

    const response = await GetAPI(
      apiAxios,
      `/usuarios/${sessao.authToken.idUsuario}`,
    );
    setLoading(false);

    if (response.success) {
      setFormData(response.data);
      carregarAvatar(response.data.id);
    } else {
      setAvisoErro(response.errorMessage || "Erro ao carregar usuário.");
    }
  };

  useEffect(() => {
    buscarUsuario();
  }, []);

  const carregarAvatar = async (id) => {
    //Carrega identificação das imagens
    const response = await GetAPI(apiAxios, "/usuario/avatar/" + id, {
      responseType: "blob",
    });

    // Cria uma URL temporária para o blob recebido
    const blobUrl = URL.createObjectURL(response.data);

    setFormData((prev) => ({
      ...prev,
      avatarUrl: blobUrl,
    }));
  };

  // Se o valor do campo for uma string, converte para maiúsculas
  const handleChange = (event, tam) => {
    const { name, value } = event.target;

    let valor = value;
    //Limita tamanho do campo
    if (typeof value === "string") {
      valor = value.slice(0, tam);
    }

    //Se for senha, não converte para maiusculas
    if (name === "senha") {
      setSenhaValida(validarSenha(valor));
      setFormData((prevData) => ({
        ...prevData,
        senha: valor,
      }));
      return;
    }

    setFormData((prevData) => ({
      ...prevData,
      [name]:
        typeof value === "string"
          ? name === "email"
            ? valor.toLowerCase()
            : valor.toUpperCase()
          : valor,
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setAvisoErro("");
    setAvisoSucesso("");

    if (formData.senha || confSenha.length > 0) {
      if (formData.senha !== confSenha) {
        setAvisoErro("A senha e a confirmação de senha não coincidem.");
        return;
      }
    }

    if (formData.senha && formData.senha.length > 0) {
      //Validar senha
      if (!validarSenha(formData.senha)) {
        setAvisoErro("Senha muito fraca.");
        return;
      }
    }

    // Validação de E-mail
    if (!validarEmail(formData.email)) {
      setAvisoErro("E-mail inválido.");
      setEmailError(true);
      return;
    }

    const registro = {
      id: formData.id,
      nome: formData.nome,
      cargo: formData.cargo,
      email: formData.email,
      senha: formData.senha,
      status: formData.status,
      idEmpresa: formData.idEmpresa,
      idPerfil: formData.idPerfil,
      tipo: formData.tipo,
      datAceite: formData.datAceite 
    };

    setLoading(true);

    const response = await PutAPI(apiAxios, "/usuario", registro);

    if (response.success) {
      setFormData((prev) => ({
        ...prev,
        ...response.data,
        espacoUtilizado: prev.espacoUtilizado, // garante que não zera
      }));

      //Exibe mensagem de sucesso por 5 segundos e limpa a tela
      setAvisoSucesso("Usuário atualizado com sucesso!");
    } else {
      setAvisoErro(response.errorMessage || "Erro ao atualizar usuário.");
    }
    setLoading(false);
  };

  const handleValidarEmail = (event) => {
    const { value } = event.target;

    if (!validarEmail(value)) {
      setAvisoErro("E-mail inválido");
      setEmailError(true);
    } else {
      setEmailError(false);
    }
  };

  const handleValidarSenha = (event) => {
    const { value } = event.target;

    if (value && value.length > 0 && !validarSenha(value)) {
      setAvisoErro("Senha muito fraca.");
      setSenhaValida(false);
    } else {
      setSenhaValida(true);
    }
  };

  const handleVoltar = () => {
    navigate("/home");
  };

  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };
  const toggleConfirmPasswordVisibility = () => {
    setShowConfirmPassword((prev) => !prev);
  };

  const uploadAvatar = async (file) => {
    const fd = new FormData();
    fd.append("file", file);

    const resp = await apiAxios.post(`/usuario/avatar/${formData.id}`, fd, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    return resp.data;
  };

  // Função para processar a nova imagem selecionada
  const handleImageChange = async (e) => {
    setAvisoErro("");
    setAvisoSucesso("");
    setLoading(true);

    const file = e.target.files?.[0];
    if (!file) return;

    //permite escolher o mesmo arquivo novamente
    e.target.value = "";

    // valida tamanho
    if (file.size > MAX_SIZE) {
      setAvisoErro("Imagem maior que 2MB.");
      return;
    }

    // valida extensão (backend aceita apenas .png ou .jpg)
    const ext = file.name.split(".").pop()?.toLowerCase();
    const allowedExt = ["png", "jpg"];
    if (!ext || !allowedExt.includes(ext)) {
      setAvisoErro("Arquivo deve ser PNG ou JPG.");
      return;
    }

    // valida mime-type (mais confiável que só extensão)
    const allowedMime = ["image/png", "image/jpeg"];
    if (!allowedMime.includes(file.type)) {
      setAvisoErro("Tipo de arquivo inválido. Use PNG ou JPG.");
      return;
    }

    // preview local imediato
    const previewUrl = URL.createObjectURL(file);
    setFormData((prev) => ({ ...prev, avatarUrl: previewUrl }));

    try {
      setLoading(true);
      setAvisoErro("");
      setAvisoSucesso("");

      await uploadAvatar(file);

      // Recarrega do backend (opcional, mas garante que está pegando o arquivo salvo)
      await carregarAvatar(formData.id);

      setAvisoSucesso("Avatar atualizado com sucesso!");
    } catch (err) {
      setAvisoErro("Falha ao enviar avatar.");
    } finally {
      setLoading(false);

      // limpa URL temporária do preview (evita vazamento de memória)
      URL.revokeObjectURL(previewUrl);
    }
  };

  return (
    <div>
      {/***************************************** AVISOS **********************************/}
      <PageTitle
        caption="Minha Conta"
        setAvisoErro={setAvisoErro}
        avisoErro={avisoErro}
        avisoSucesso={avisoSucesso}
        setAvisoSucesso={setAvisoSucesso}
        loading={loading}
        accentStyle
      />
      {/***************************************** AVISOS **********************************/}
      <Box sx={{ flexGrow: 1, p: 3 }}>
        <form onSubmit={handleSubmit}>
          {/* Grid Container Principal que divide a tela em duas colunas */}
          <Grid container spacing={4}>
            {/* --- COLUNA DA ESQUERDA: AVATAR --- */}
            <Grid
              item
              xs={12}
              md={3}
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                borderRight: { md: "1px solid #e0e0e0" }, // Linha divisória lateral
                pr: { md: 4 },
                pb: { xs: 4, md: 0 },
                textAlign: "center",
              }}
            >
              <Avatar
                src={previewUrl || formData.avatarUrl}
                sx={{
                  width: 160,
                  height: 160,
                  mb: 2,
                  border: "1px solid #ccc",
                }}
              />

              <Button
                variant="outlined"
                component="label"
                startIcon={<AttachFileIcon />}
                sx={{
                  textTransform: "none",
                  color: "#1a3865",
                  borderColor: "#1a3865",
                }}
              >
                Atualizar imagem
                <input type="file" hidden onChange={handleImageChange} />
              </Button>

              <Typography
                variant="caption"
                sx={{ mt: 1, color: "text.secondary" }}
              >
                PNG/JPG - até 2MB
              </Typography>
            </Grid>

            {/* --- COLUNA DA DIREITA: CAMPOS DO FORMULÁRIO --- */}
            <Grid item xs={12} md={8}>
              <Grid container spacing={2}>
                {/* Nome */}
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Nome:"
                    variant="outlined"
                    value={formData.nome}
                    onChange={(e) => handleChange(e, 50)}
                    name="nome"
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <PersonIcon />
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>

                {/* Email */}
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Email:"
                    variant="outlined"
                    onChange={handleChange}
                    onBlur={(e) => handleValidarEmail(e, 50)}
                    name="email"
                    value={formData.email}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <EmailIcon />
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>

                {/* Cargo */}
                <Grid item xs={12} md={12}>
                  <TextField
                    fullWidth
                    label="Cargo:"
                    variant="outlined"
                    name="cargo"
                    value={formData.cargo}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <BadgeIcon />
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>

                {/* Perfil */}
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    disabled
                    label="Perfil:"
                    variant="outlined"
                    name="nomPerfil"
                    value={formData.nomPerfil}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <BadgeIcon />
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>

                {/* Aceite */}
                <Grid item xs={12} md={6}>
                  <TextField
                    label="Aceite do Termo de Uso"
                    value={formData.datAceite || ""}
                    disabled
                    fullWidth
                  />
                </Grid>

                {/* Senha */}
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    label="Senha:"
                    type={showPassword ? "text" : "password"}
                    variant="outlined"
                    name="senha"
                    value={formData.senha}
                    onChange={(e) => handleChange(e, 64)}
                    onBlur={(e) => handleValidarSenha(e)}
                    error={!!formData.senha && !senhaValida}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <LockIcon />
                        </InputAdornment>
                      ),
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            onClick={togglePasswordVisibility}
                            edge="end"
                          >
                            {showPassword ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                    autoComplete="new-password"
                  />
                </Grid>

                {/* Confirmação de Senha */}
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    label="Confirmação de Senha:"
                    variant="outlined"
                    type={showConfirmPassword ? "text" : "password"}
                    name="confirmacaoSenha"
                    value={confSenha}
                    onChange={(e) => setConfSenha(e.target.value)}
                    autoComplete="new-password"
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <LockIcon />
                        </InputAdornment>
                      ),
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            onClick={toggleConfirmPasswordVisibility}
                            edge="end"
                          >
                            {showConfirmPassword ? (
                              <VisibilityOff />
                            ) : (
                              <Visibility />
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>
              </Grid>
            </Grid>

            {/* --- RODAPÉ: LINHA HORIZONTAL E BOTÕES --- */}
            <Grid item xs={12}>
              <Box
                sx={{
                  mt: 2,
                  pt: 3,
                  borderTop: "1px solid #e0e0e0", // Linha horizontal
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Button
                  variant="contained"
                  size="large"
                  sx={{ backgroundColor: "#1a3865" }}
                  onClick={handleVoltar}
                >
                  Cancelar
                </Button>

                <Button
                  variant="contained"
                  color="primary"
                  size="large"
                  sx={{ backgroundColor: "#1a3865" }}
                  onClick={handleSubmit}
                  type="submit"
                >
                  Salvar
                </Button>
              </Box>
            </Grid>
          </Grid>
        </form>
      </Box>
    </div>
  );
};

export default MinhaContaAlterar;
